import React from "react";
import {
  CardDetails,
  Info,
  Label,
  Name,
  PeopleSubtitle,
  TextColumnWrapper,
  UserImage,
  Content,
} from "./styled";
import { useTheme } from "styled-components";
import { ViewOptions } from "../ViewSelector";
import { useOrgChartStore } from "../../../../stores/use-org-chart-store";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import { useStyleguideColors } from "../../../../hooks/use-styleguide-colors";

function CardContent({
  viewType,
  userInfo,
  elements: { firstElementValue, secondElementValue },
}) {
  const theme = useTheme();
  const { data } = useOrgChartStore((state) => ({
    data: state.data,
  }));

  const { styleguideSetup } = useOpticsStore((state) => ({
    styleguideSetup: state.styleguideSetup,
  }));

  const styleguideColors = useStyleguideColors({
    styleguideSetup,
  });

  if (viewType === ViewOptions.CARD) {
    return (
      <Content>
        <CardDetails>
          <UserImage src={userInfo?.profilePictureSrc} />

          <Name color={theme.orgchart.name} title={userInfo?.name || ""}>
            {userInfo?.name}
          </Name>
          {firstElementValue && (
            <PeopleSubtitle
              color={
                data.config?.lineColor?.light ||
                styleguideColors?.accent?.light ||
                "#4C9AFF"
              }
            >
              {firstElementValue}
            </PeopleSubtitle>
          )}
        </CardDetails>
        {secondElementValue && (
          <Label color={theme.orgchart.info}>{secondElementValue}</Label>
        )}
      </Content>
    );
  }

  return (
    <>
      <UserImage
        src={userInfo?.profilePictureSrc}
        style={{ marginBottom: "0px" }}
      />
      <TextColumnWrapper style={{ flex: "1" }}>
        <Name
          color={theme.orgchart.name}
          title={userInfo?.name || ""}
          style={{ fontSize: "17px", minHeight: "20px", textAlign: "left" }}
        >
          {userInfo?.name}
        </Name>
        {firstElementValue && (
          <PeopleSubtitle
            color={
              data.config?.lineColor?.light ||
              styleguideColors?.accent?.light ||
              "#4C9AFF"
            }
            style={{ textAlign: "left" }}
          >
            {firstElementValue}
          </PeopleSubtitle>
        )}
        {secondElementValue && (
          <Label color={theme.orgchart.info}>{secondElementValue}</Label>
        )}
      </TextColumnWrapper>
    </>
  );
}

export default CardContent;
